export { valsOrNone } from '@quromedical/utils';

/**
 * Find a value in the array where a specific property is defined
 * @param key key of property to find
 * @returns Value in array that contains a defined value for the requested pro
 */
export const findProp =
  <T, K extends keyof T>(key: K) =>
  (list: T[] = []): T[K] | undefined => {
    const found = list.find((a) => a[key]);

    return found && found[key];
  };
